import { useTranslation } from "next-i18next";
import Numeral from "numeral";
import Link from "next/link";

import Text from "ab-text";
import NormalLink from "ab-link";
import Button from "ab-button";

import "./product-card.scss";

const ProductCard = ({
  product,
  src,
  label,
  title,
  description,
  personalizar,
  hidePrice,
  href,
  i18n,
  esEstuche,
  inStock,
  isSeleccionNavidad,
}) => {
  const { t } = useTranslation("common", { i18n });

  if (Numeral.locales["abadia"] === undefined) {
    Numeral.register("locale", "abadia", {
      delimiters: {
        thousands: ".",
        decimal: ",",
      },
      abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t",
      },
      ordinal: function (number) {
        var b = number % 10;
        return b === 1 || b === 3
          ? "er"
          : b === 2
            ? "do"
            : b === 7 || b === 0
              ? "mo"
              : b === 8
                ? "vo"
                : b === 9
                  ? "no"
                  : "to";
      },
      currency: {
        symbol: "€",
      },
    });
  }

  const _label = label?.includes("-") ? label?.split(" - ") : label;

  Numeral.locale("abadia");
  return (
    <Link prefetch={false} href={href.replace("/tienda", t("/tienda"))}>
      <a className={`product-card`}>
        <div>
          <img src={src} alt={title}></img>
        </div>

        <Text element="span" className="titles">
          {title}
        </Text>
        {(!esEstuche && !label) || (esEstuche && !inStock) ? (
          <Text element="span" className="title">
            {t("no-stock")}
          </Text>
        ) : null}
        {hidePrice || !label ? null : (
          <Text element="span" className="title">
            {`${isSeleccionNavidad ? "" : t("desde")} ${label?.includes("-")
                ? Numeral(_label[0]).format("1,000.00$") +
                " - " +
                Numeral(_label[1]).format("1,000.00$")
                : Numeral(label).format("1,000.00$")
              }`}
          </Text>
        )}

        {description ? (
          <Text className="description">
            {description}
            <Button type="mas" />
          </Text>
        ) : null}

        {personalizar ? <NormalLink text={t("configurar")} /> : null}
      </a>
    </Link>
  );
};

export default ProductCard;
